import { render } from "./EmpresaImageDefault.vue?vue&type=template&id=415f00c6&scoped=true"
import script from "./EmpresaImageDefault.vue?vue&type=script&lang=js"
export * from "./EmpresaImageDefault.vue?vue&type=script&lang=js"

import "./EmpresaImageDefault.vue?vue&type=style&index=0&id=415f00c6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415f00c6"]])

export default __exports__